// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store' // Vuex全局状态管理
// 引入列表公共组件
import BaseList from '@/components/common/base-list.vue'
import InputNumbers from '@/components/common/input-number.vue'
import IconSvg from '@/components/icon-svg/'
// 引入分页全局配置
import getPage from '@/assets/page.js'
// 引入枚举 全局计算属性和过滤器
import {
    computedMapDict,
    filtersMapDict
} from '@/assets/dict'
// 引入自有公共方法
import assist from '@/utils/assist'
import method from '@/utils/method'
import {
    filterNum,
    filterZero,
    formatterMoney
} from '@/utils/filter'
import "@/assets/style/index.scss"
import "@/assets/style/common.scss"
import '@/assets/iconfont/iconfont.css' // 引入图标字体
import {
    storageMsg
} from "./utils/storage";
import {
    getCookie,
    Token,
    setCookie
} from './utils/cookie'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import JmTable from 'jm-table'
Vue.use(JmTable)
import { UTable, UTableColumn } from 'umy-ui';
Vue.component(UTable.name, UTable);
Vue.component(UTableColumn.name, UTableColumn);

import {
    getAgain
} from '@/api/auth/auth'
import {
    getWjAgain
} from '@/api/auth/auth'
// 按需引入element组件
import {
    Aside,
    Autocomplete,
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Card,
    Carousel,
    CarouselItem,
    Checkbox,
    CheckboxGroup,
    Col,
    Container,
    DatePicker,
    Dialog,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Form,
    FormItem,
    Header,
    Icon,
    Input,
    InputNumber,
    Loading,
    Main,
    Menu,
    MenuItem,
    MenuItemGroup,
    Message,
    MessageBox,
    Option,
    Pagination,
    Progress,
    Radio,
    Row,
    Select,
    Step,
    Steps,
    Submenu,
    Table,
    TableColumn,
    TabPane,
    Tabs,
    Tag,
    Tree,
    Upload,
    Alert,
    Notification,
    Tooltip,
    popover,
    ColorPicker,
    RadioGroup,
    ButtonGroup,
    scrollbar,
    Collapse,
    CollapseItem,
    RadioButton,
    Badge,
    Transfer,
    TimePicker
} from 'element-ui';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)

//引入导出接口
import derive from './api/derive/derive'
// 引入echarts
import echarts from 'echarts'

Vue.prototype.$echarts = echarts
Vue.prototype.DERIVE = derive;

Vue.component(scrollbar.name, scrollbar);
Vue.component(Button.name, Button);
Vue.component(ButtonGroup.name, ButtonGroup);
Vue.component(Select.name, Select);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Input.name, Input);
Vue.component(Radio.name, Radio);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Message.name, Message);
Vue.component(Container.name, Container);
Vue.component(Aside.name, Aside);
Vue.component(Header.name, Header);
Vue.component(Main.name, Main);
Vue.component(Menu.name, Menu);
Vue.component(MenuItem.name, MenuItem);
Vue.component(MenuItemGroup.name, MenuItemGroup);
Vue.component(Submenu.name, Submenu);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Pagination.name, Pagination);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Collapse.name, Collapse);
Vue.component(CollapseItem.name, CollapseItem);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(Option.name, Option);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Dialog.name, Dialog);
Vue.component(Radio.name, Radio);
Vue.component(Step.name, Step);
Vue.component(Steps.name, Steps);
Vue.component(Autocomplete.name, Autocomplete);
Vue.component(InputNumber.name, InputNumber);
Vue.component(Tag.name, Tag);
Vue.component(Card.name, Card);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(Upload.name, Upload);
Vue.component(Progress.name, Progress);
Vue.component(BaseList.name, BaseList);
Vue.component(InputNumbers.name, InputNumbers);
Vue.component(IconSvg.name, IconSvg)
Vue.component(Tree.name, Tree)
Vue.component(Breadcrumb.name, Breadcrumb)
Vue.component(BreadcrumbItem.name, BreadcrumbItem)
Vue.component(Alert.name, Alert)
Vue.component(Tooltip.name, Tooltip)
Vue.component(popover.name, popover)
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Notification.name, Notification)
Vue.component(ColorPicker.name, ColorPicker)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(RadioButton.name, RadioButton)
Vue.component(Badge.name, Badge);
Vue.component(Transfer.name, Transfer);
Vue.component(TimePicker.name,TimePicker);

//tabs 选项卡
Vue.component(Tabs.name, Tabs);
Vue.component(TabPane.name, TabPane);

Vue.use(Loading.directive);
// 使用element-ui 并且组件尺寸默认为small
Vue.prototype.$ELEMENT = {
    size: 'small'
};
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$maxLength = 256;
Vue.prototype.$length = 250;
Vue.prototype.$storageMsg = storageMsg;
Vue.prototype.$notify = Notification
// 分页配置
Vue.prototype.$defalutPage = getPage
// 注册自有工具库
Vue.prototype.$assist = assist
Vue.prototype.$method = method
// 全局路由跳转
Vue.prototype.goto = function (path) {
    this.$router.push(path)
}
// 全局路由返回
Vue.prototype.goback = function (path) {
    this.$router.go(-1)
}

// 自定义指令--权限控制
// 使用 v-power="'powerCode'"
// Vue.directive('power', (el, binding) => {
//     componentUpdated: {
//         // console.log(binding)//输出的是一个对象obj
//         // 获取权限码
//         const securityPermissions = store.getters.securityPermissions;
//         // 判断是否有权限
//         if (!(securityPermissions && securityPermissions.length > 0 && securityPermissions.indexOf(binding.value) !== -1)) {
//             // 异步操作获取真实dom并移除
//             setTimeout(() => {
//                 el.parentNode.removeChild(el);
//             }, 1);
//         }
//     }
// })

// 将枚举字典过滤器混入全局Vue
Vue.mixin({
    computed: {
        ...computedMapDict(),
    },
    filters: {
        ...filtersMapDict()
    },
    methods: {
        // 全局权限验证
        power(val) {
            const securityPermissions = store.getters.securityPermissions;
            return securityPermissions && securityPermissions.length > 0 && securityPermissions.indexOf(val) !== -1;
        }
    }
})

Vue.mixin({
    filters: {
        _filterNum: filterNum,
        filterZero,
        _filterMoney: formatterMoney
    }
})
const whiteList = ['/Login'] // 不重定向白名单

router.beforeEach((to, from, next) => {
    if (to.query.token) {
        setCookie(Token, to.query.token)
        sessionStorage.setItem('reportId', to.query.shipPlanNo)
    }
    // 判断是否存在token

    if (getCookie(Token)) {
        if (to.path === '/Login') {
            document.body.style.background = "#ffffff"
            next()
        } else {
            document.body.style.background = "#f3f3f3"
            // 检测到当前用户不存在更新当前用户
            if (!store.getters.currentUser.userName) {
                // getAgain().then(res => {
                //     store.commit('SET_CURRENT_USER', res.data)
                // })
                getWjAgain().then(res => {
                    let resData = res.data;
                    let currentUser = JSON.parse(localStorage.getItem("currentUserObj"));
                    let SET_CURRENT_USER = resData || currentUser
                    store.commit('SET_CURRENT_USER', SET_CURRENT_USER)
                    
					console.log("???? SET_CURRENT_USER",SET_CURRENT_USER)
                })
                console.log("????AAAAA")
                next()
            } else {
                console.log("????BBBBB")
                next()
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            console.log("????CCCC")
            next() // 在免登录白名单，直接进入
        } else {
            console.log("????DDDD")
            console.log("否则全部重定向到登录页")
            next('/Login') // 否则全部重定向到登录页
        }
    }
})

import fullscreen from 'vue-fullscreen'
Vue.config.productionTip = false
Vue.use(fullscreen)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js